module.exports = __webpack_public_path__ + "static/media/task.ab84278f.png";